import { useState } from 'react';
import { t, useTranslation } from '../i18n';

interface Props {
  contacts: string[];
  onCancel: () => void;
  onShare: (syphraxId: string) => void;
}

export default function ShareContactModal({ contacts, onCancel, onShare }: Props) {
  useTranslation();
  const [manual, setManual] = useState('');
  const [filter, setFilter] = useState('');

  const filtered = contacts.filter((c) => c.toLowerCase().includes(filter.toLowerCase()));

  function shareManual() {
    const cleaned = manual.trim().toLowerCase();
    if (!cleaned) return;
    onShare(cleaned);
  }

  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{t('modal.share.title')}</h2>
        <p className="hint">{t('modal.share.hint')}</p>
        <input
          type="text"
          placeholder={t('modal.share.filter')}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          autoCapitalize="none"
          autoCorrect="off"
        />
        <ul className="share-contact-list">
          {filtered.length === 0 && <li className="empty-row">{t('modal.share.empty')}</li>}
          {filtered.map((c) => (
            <li key={c}>
              <button className="ghost" onClick={() => onShare(c)}>{c}</button>
            </li>
          ))}
        </ul>
        <div className="manual-row">
          <input
            type="text"
            placeholder={t('modal.share.manual')}
            value={manual}
            onChange={(e) => setManual(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && shareManual()}
            autoCapitalize="none"
            autoCorrect="off"
          />
          <button className="primary" onClick={shareManual} disabled={!manual.trim()}>{t('modal.share.btn')}</button>
        </div>
        <div className="modal-actions">
          <button type="button" className="ghost" onClick={onCancel}>{t('common.close')}</button>
        </div>
      </div>
    </div>
  );
}
